import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SearchUrlFormValueObject} from '../ValueObjects/SearchUrlFormValueObject.js'

class GetSpecsUrlFormUseCase extends UseCase {
  #config
  #searchUrlFormValueObject

  constructor({config}) {
    super()
    this.#config = config
    this.#searchUrlFormValueObject = SearchUrlFormValueObject
  }

  static create({config}) {
    return new GetSpecsUrlFormUseCase({config})
  }

  @tracer({metric: 'GetSpecsUrlFormUseCase#execute'})
  @AsyncInlineError()
  async execute({nextField = 'makes', params = {}} = {}) {
    const searchUrlVO = this.#searchUrlFormValueObject.fromNextFieldAndParamsToValueObject({
      config: this.#config,
      nextField,
      params
    })

    return searchUrlVO.getUrl()
  }
}

export const factory = GetSpecsUrlFormUseCase.create
